import {
    SAVE_EMAIL_SIGN_UP_DATA,
    SIGN_UP_FOR_EMAIL_SUCCESS,
    SIGN_UP_FOR_EMAIL_ERROR
} from '../actions/emailSignupActions';

export function emailSignUpReducer(state = {}, action) {
    switch (action.type) {
        case SAVE_EMAIL_SIGN_UP_DATA:
            return Object.assign({}, state, {
                formData: action.payload.formData
            });
        case SIGN_UP_FOR_EMAIL_SUCCESS:
            return Object.assign({}, state, {
                formData: {},
                error: null,
                signUpSuccessful: true
            });
        case SIGN_UP_FOR_EMAIL_ERROR:
            return Object.assign({}, state, {
                error: action.payload.error,
                signUpSuccessful: false
            });
        default:
            return state;
    }
}
